module.exports = "data:application/x-font-ttf;base64,"